import Vue from 'vue'

import ElementUI from 'element-ui'
import App from './App.vue'
import router from './router'
import echarts from 'echarts'
import './plugins/element.js'
import './plugins/moment.js'
import './plugins/axios.js'
import './plugins/common.js'
import './utils/rem'
import 'normalize.css'// A modern alternative to CSS resets
import './styles/c.less'
import './components'
import './filter'

Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
